import snow from './snow.svg';
import warning from './warning.svg';
import parking from './parking.svg';
import repair from './repair.svg';
import heart from './heart.svg';
import camera from './camera.svg';
import calendar from './calendar.svg';

const all = {
    snow,
    warning,
    parking,
    repair,
    heart,
    camera,
    calendar
};

export default all;